import React from "react";
import { History } from "lucide-react";
import { fmtMoney } from "../../lib/api";

export const InvoiceEditHistory = ({ invoice }) => {
  const history = [...(invoice?.edit_history || [])].reverse();
  if (!history.length) return null;
  return (
    <details className="mt-2 rounded-sm border border-border bg-background" data-testid={`invoice-edit-history-${invoice.id}`}>
      <summary className="flex cursor-pointer list-none items-center gap-2 px-3 py-2 text-xs font-semibold text-muted-foreground" data-testid={`invoice-edit-history-toggle-${invoice.id}`}>
        <History className="h-3.5 w-3.5" />Edit history ({history.length})
      </summary>
      <div className="border-t border-border" data-testid={`invoice-edit-history-rows-${invoice.id}`}>
        {history.map((entry) => (
          <div key={entry.id} className="border-b border-border px-3 py-2 text-xs last:border-b-0" data-testid={`invoice-edit-history-row-${entry.id}`}>
            <div className="flex flex-wrap justify-between gap-2"><strong>{entry.reason || "Invoice edited"}</strong><span className="text-muted-foreground">{entry.edited_at ? new Date(entry.edited_at).toLocaleString() : ""}</span></div>
            <div className="mt-0.5 text-muted-foreground">{entry.edited_by || "Management user"} · {fmtMoney(entry.before?.total || 0)} → {fmtMoney(entry.after?.total || 0)}{entry.was_sent ? " · edited after sending" : ""}</div>
          </div>
        ))}
      </div>
    </details>
  );
};